/** Brand Personality registry — the character the design projects. */

export const BRAND_PERSONALITIES = [
  { id: 'luxury', name: 'Luxury' },
  { id: 'premium', name: 'Premium' },
  { id: 'minimal', name: 'Minimal' },
  { id: 'modern', name: 'Modern' },
  { id: 'elegant', name: 'Elegant' },
  { id: 'corporate', name: 'Corporate' },
  { id: 'friendly', name: 'Friendly' },
  { id: 'creative', name: 'Creative' },
  { id: 'bold', name: 'Bold' },
  { id: 'vintage', name: 'Vintage' },
  { id: 'retro', name: 'Retro' },
  { id: 'organic', name: 'Organic' },
  { id: 'playful', name: 'Playful' },
  { id: 'sophisticated', name: 'Sophisticated' },
  { id: 'energetic', name: 'Energetic' },
];
